const {
  GET_LOCATION_LIST,
  GET_LOCATION_LIST_FAILED,
  GET_LOCATION_LIST_SUCCESS,

  EXPORT_LOCATION_LIST,
  EXPORT_LOCATION_LIST_FAILED,
  EXPORT_LOCATION_LIST_SUCCESS,

  DELETE_LOCATION,
  DELETE_LOCATION_FAILED,
  DELETE_LOCATION_SUCCESS,

  GET_ADVANCE_BOOKING_CHARTS,
  GET_ADVANCE_BOOKING_CHARTS_SUCCESS,
  GET_ADVANCE_BOOKING_CHARTS_FAILED,

  GET_STAY_NIGHTS_CHARTS,
  GET_STAY_NIGHTS_CHARTS_SUCCESS,
  GET_STAY_NIGHTS_CHARTS_FAILED,

  GET_BOOKING_STATUS_RATIO,
  GET_BOOKING_STATUS_RATIO_SUCCESS,
  GET_BOOKING_STATUS_RATIO_FAILED,

  GET_REVENUE_DISTRIBUTION_ACCOUNT_LEVELS,
  GET_REVENUE_DISTRIBUTION_ACCOUNT_LEVELS_SUCCESS,
  GET_REVENUE_DISTRIBUTION_ACCOUNT_LEVELS_FAILED,
} = require('./actionTypes');

const initialState = {
  isLoadingLocationList: true,
  isLoadingExportLocationList: false,
  isLoadingDeleteLocation: false,
  isLoadingAdvanceBookingCharts: false,
  isLoadingStayNightsCharts: false,
  isLoadingBookingStatusRatio: false,
  isLoadingRevenueDistributionAccountLevels: false,
  locationList: [],
  totalLocation: 0,
  advanceBookingCharts: [],
  stayNightsCharts: [],
  bookingStatusRatio: null,
  revenueDistributionAccountLevels: [],
};

const location = (state = initialState, action) => {
  switch (action.type) {
    case GET_LOCATION_LIST:
      return {
        ...state,
        isLoadingLocationList: true,
      };

    case GET_LOCATION_LIST_SUCCESS:
      return {
        ...state,
        locationList: action.payload.data,
        totalLocation: action.payload.total,
        isLoadingLocationList: false,
      };

    case GET_LOCATION_LIST_FAILED:
      return {
        ...state,
        isLoadingLocationList: false,
      };

    case EXPORT_LOCATION_LIST:
      return {
        ...state,
        isLoadingExportLocationList: true,
      };

    case EXPORT_LOCATION_LIST_SUCCESS:
      return {
        ...state,
        isLoadingExportLocationList: false,
      };

    case EXPORT_LOCATION_LIST_FAILED:
      return {
        ...state,
        isLoadingExportLocationList: false,
      };

      // DELETE LOCATION
    case DELETE_LOCATION:
      return {
        ...state,
        isLoadingDeleteLocation: true,
      };

    case DELETE_LOCATION_SUCCESS:
      return {
        ...state,
        locationList: state.locationList.filter(
          (item) => item._id !== action.payload.locationId,
        ),
        isLoadingDeleteLocation: false,
      };

    case DELETE_LOCATION_FAILED:
      return {
        ...state,
        isLoadingDeleteLocation: false,
      };

    case GET_ADVANCE_BOOKING_CHARTS:
      return {
        ...state,
        isLoadingAdvanceBookingCharts: true,
      };

    case GET_ADVANCE_BOOKING_CHARTS_SUCCESS:
      return {
        ...state,
        isLoadingAdvanceBookingCharts: false,
        advanceBookingCharts: action.payload,
      };

    case GET_ADVANCE_BOOKING_CHARTS_FAILED:
      return {
        ...state,
        isLoadingAdvanceBookingCharts: false,
      };

    case GET_STAY_NIGHTS_CHARTS:
      return {
        ...state,
        isLoadingStayNightsCharts: true,
      };

    case GET_STAY_NIGHTS_CHARTS_SUCCESS:
      return {
        ...state,
        isLoadingStayNightsCharts: false,
        stayNightsCharts: action.payload,
      };

    case GET_STAY_NIGHTS_CHARTS_FAILED:
      return {
        ...state,
        isLoadingStayNightsCharts: false,
      };

    case GET_BOOKING_STATUS_RATIO:
      return {
        ...state,
        isLoadingBookingStatusRatio: true,
      };

    case GET_BOOKING_STATUS_RATIO_SUCCESS:
      return {
        ...state,
        isLoadingBookingStatusRatio: false,
        bookingStatusRatio: action.payload,
      };

    case GET_BOOKING_STATUS_RATIO_FAILED:
      return {
        ...state,
        isLoadingBookingStatusRatio: false,
      };

    case GET_REVENUE_DISTRIBUTION_ACCOUNT_LEVELS:
      return {
        ...state,
        isLoadingRevenueDistributionAccountLevels: true,
      };

    case GET_REVENUE_DISTRIBUTION_ACCOUNT_LEVELS_SUCCESS:
      return {
        ...state,
        isLoadingRevenueDistributionAccountLevels: false,
        revenueDistributionAccountLevels: action.payload,
      };

    case GET_REVENUE_DISTRIBUTION_ACCOUNT_LEVELS_FAILED:
      return {
        ...state,
        isLoadingRevenueDistributionAccountLevels: false,
      };

    default:
      return state;
  }
};

export default location;
